import React from 'react'
import './Presence.css';
import Map from './Map.js';
import ContactButton from '../componnents/contactbutton/ContactButton';

const Presence = () => {
  return (
    <>
    <div className="section11">
    <div className="container11">
      <div className="content-section11">
        <div className="title11">
          <h1>Our Presence</h1>
        </div>
        <div className="content11">
          {/* <h3>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Excepturi quasi odio, numquam fugiat illum similique!</h3> */}
          {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt inventore vitae doloremque dolore ut iusto recusandae beatae esse mollitia voluptate optio atque totam autem non blanditiis, odit commodi ullam repellat.</p>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt inventore vitae doloremque dolore ut iusto recusandae beatae esse mollitia voluptate optio atque totam autem non blanditiis, odit commodi ullam repellat.</p>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt inventore vitae doloremque dolore ut iusto recusandae beatae esse mollitia voluptate optio atque totam autem non blanditiis, odit commodi ullam repellat.</p> */}
       <p>We are well-known producers and exporters of Woven Fabric Rolls and Bags at Somnath Polytex. We have a strong presence in several countries. Our goods are highly regarded all around the world.</p>
        </div>
        <div className="social">
       
        </div>
      </div>
     
    </div>
  </div>
<Map />
<ContactButton />
</>
  )
}

export default Presence
